import { useState } from "react";
import {
    signInWithEmailAndPassword,
  } from "firebase/auth";
import { auth } from "../../Firebase/Config";
import { useAuthContext } from '../CustomHooks/useAuthContext'

export const useLogin = () => {
    const [error, setError] = useState(null)
    const {dispatch} = useAuthContext()

    const login = async (email, password) => {
        setError(null)
        await signInWithEmailAndPassword(auth, email, password)
        .then((res) => {
            dispatch({type: 'LOGIN', payload: res.user})
        }).catch((err) => {
            setError(err.message)
        })
    }

    return { error, login}
}